export class Logger {
  constructor(private readonly name: string) {}
  public debug(msg: string) {
    // eslint-disable-next-line no-console
    console.log(`${this.name}:${msg}`)
  }
}
